<template>
  <fragment>
    <div class="body-wrapper-inner">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="d-sm-flex gap-1 align-items-center mb-4">
              <h5 class="card-title fw-semibold mb-3 mb-sm-0 me-auto">Dokumentasi Pengguna</h5>
              <form @submit.prevent="getDataList" class="d-flex gap-1">
                <div class="input-group">
                  <input
                    v-model="cariTitle"
                    type="text"
                    class="form-control bg-light"
                    placeholder="Pencarian..."
                  >
                  <button type="submit" class="btn btn-primary">Cari</button>
                </div>
              </form>
            </div>
            <hr class="border-0 bg-primary pt-1 rounded my-4">

            <div class="table-responsive">
              <table class="table align-middle table-striped table-hover">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th class="w-100" scope="col">
                      <a href="#" class="link-dark">
                        Judul
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                    <th class="text-center text-nowrap" scope="col">
                      <a href="#" class="link-dark">
                        Terakhir Diperbarui
                        <i class="ti ti-caret-up-down-filled"></i>
                      </a>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(req, idx) in dataList" :key="req.id">
                    <th scope="row">{{ idx + 1 }}</th>
                    <td>
                      <a
                        class="link-primary fw-bold"
                        href="#"
                        @click="edit(req.id)"
                        title="Detail"
                        data-bs-toggle="modal"
                        data-bs-target="#modalDetailUserFaq"
                      >{{req.title}}</a>
                    </td>
                    <td class="text-center">{{formatDate(req.updatedAt)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <b-pagination
              class="justify-content-center"
              v-model="page"
              :total-rows="countDataList"
              :per-page="pageSize"
              prev-text="Previous"
              next-text="Next"
              @change="handlePageChange"
              size="md"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detail User Docs -->
    <div
      class="modal fade"
      id="modalDetailUserFaq"
      tabindex="-1"
      aria-labelledby="modalDetailUserFaqLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="modalDetailUserFaqLabel">FAQ</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <label class="form-label fs-4 mb-4">{{form.title}}</label>
            <div v-html="form.content"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-dark" data-bs-dismiss="modal">Tutup</button>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex'
import Highlight from '../components/Highlight.vue'
import EmptyPlaceholder from '../components/EmptyPlaceholder.vue'

export default {
	components: {
		Highlight,
		EmptyPlaceholder
	},
	data() {
		return {
			token: localStorage.getItem('token'),
			order: 'desc',
			page: 1,
			pageSize: 30,
			pageSizes: [10, 20, 50],
			form: {
				id: '',
				title: '',
				content: '',
				attachment: '',
				page_visibility: '',
				type: '',
				statusId: ''
			},
			cariTitle: '',
			formTitle: 'Add New',
			url: 'faq',
			method: 'post'
		}
	},
	created() {
		if (!this.token) {
			this.$router.push('/login')
		}
		this.getDataList()
		// this.$store.commit("settings/setMenuActive", "dc-location");
		// this.$store.dispatch("auth/getNotif");
	},
	computed: {
		...mapGetters({
			dataList: 'location/getDCLocation',
			countDataList: 'location/getCountDCLocation'
		})
	},
	methods: {
		getDataList(reset_pagination, from = 'all') {
			if (reset_pagination) {
				this.page = 1
			}
			this.$store
				.dispatch('location/getData', {
					url: `faq`,
					params: {
						title: this.cariTitle,
						type: 'faq',
						offset: this.page - 1,
						limit: this.pageSize,
						order: this.order
					}
				})
				.then(() => {
					console.log('doneeeeeeeeeee')
				})
		},
		handlePageChange(value) {
			this.page = value
			this.getDataList()
		},
		handlePageSizeChange(event) {
			this.pageSize = parseInt(event.target.value)
			this.page = 1
			this.getDataList()
		},
		edit(id) {
			let data = this.dataList.find((o) => o.id === id)
			this.form.title = data.title
			this.form.content = data.content
		},
		formatDate(dateStr) {
			if (!dateStr) return '-' // biar aman kalau null/undefined/kosong
			const d = new Date(dateStr)
			const y = d.getUTCFullYear()
			const m = String(d.getUTCMonth() + 1).padStart(2, '0')
			const day = String(d.getUTCDate()).padStart(2, '0')
			const h = String(d.getUTCHours()).padStart(2, '0')
			const min = String(d.getUTCMinutes()).padStart(2, '0')
			return `${day}/${m}/${y} ${h}:${min} `
		}
	}
}
</script>

<style lang="scss">
.file {
	position: relative;
	overflow: hidden;
}

.input-file {
	position: absolute;
	font-size: 50px;
	opacity: 0;
	right: 0;
	top: 0;
}
</style>
